/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class LicenseBenefitHubDiscountsRequest {
    getFixupPrototypeFunction() { return LicenseBenefitHubDiscountsRequest.fixupPrototype; }

    static newInstance(model: Partial<LicenseBenefitHubDiscountsRequest>): LicenseBenefitHubDiscountsRequest {
        let obj = Object.assign(new LicenseBenefitHubDiscountsRequest(), model);
        LicenseBenefitHubDiscountsRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<LicenseBenefitHubDiscountsRequest>): LicenseBenefitHubDiscountsRequest {
        if (!model) return null;
        return LicenseBenefitHubDiscountsRequest.newInstance(<LicenseBenefitHubDiscountsRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: LicenseBenefitHubDiscountsRequest) {
        if (!obj) return;

        models.LicenseBenefitHubDiscountsRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: LicenseBenefitHubDiscountsRequest): boolean {
        Object.setPrototypeOf(obj, LicenseBenefitHubDiscountsRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.page === undefined) {
            this.page = 0;
        }
        if (this.limit === undefined) {
            this.limit = 0;
        }
    }

    /**
     * page number.Example 'page':'1'
     */
    page: number;

    /**
     * records limits.Example 'limit':'10'
     */
    limit: number;

    /**
     * currency of the cost. Example 'currency':'USD'
     */
    currency: models.Currency;

    /**
     * Cloud Provider for the cloud account
     */
    cloud_provider: models.CloudServiceName;

}
